var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndividualIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    className: "visibility",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1059.1251-1776.9997h-4l1.281,1.281a9.002,9.002,0,0,1-6.281,3.651v-8.033a5.00063,5.00063,0,0,0,4-4.899,4.9999,4.9999,0,0,0-5-5,5.00054,5.00054,0,0,0-5,5,5.00063,5.00063,0,0,0,4,4.899v8.034a9.02985,9.02985,0,0,1-6.275-3.658l1.275-1.275h-4v4l1.287-1.287a11.04494,11.04494,0,0,0,8.713,4.287,11.0038,11.0038,0,0,0,8.707-4.293l1.293,1.293Zm-13-8a2.99981,2.99981,0,0,1,3-3,2.99981,2.99981,0,0,1,3,3,2.99981,2.99981,0,0,1-3,3A2.99981,2.99981,0,0,1-1072.1251-1784.9997Z",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1579.1251-1987.9997h-4l1.281,1.281a9.002,9.002,0,0,1-6.281,3.651v-8.033a5.00063,5.00063,0,0,0,4-4.899,4.9999,4.9999,0,0,0-5-5,5.00054,5.00054,0,0,0-5,5,5.00063,5.00063,0,0,0,4,4.899v8.034a9.02985,9.02985,0,0,1-6.275-3.658l1.275-1.275h-4v4l1.287-1.287a11.04494,11.04494,0,0,0,8.713,4.287,11.0038,11.0038,0,0,0,8.707-4.293l1.293,1.293Zm-13-8a2.99981,2.99981,0,0,1,3-3,2.99981,2.99981,0,0,1,3,3,2.99981,2.99981,0,0,1-3,3A2.99981,2.99981,0,0,1-1592.1251-1995.9997Z",
    fill: "none",
    clipRule: "evenodd"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Only visible to you") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,8H17V6A5,5,0,0,0,7,6V8H6a1.99945,1.99945,0,0,0-2,2V20a1.99945,1.99945,0,0,0,2,2H18a1.99945,1.99945,0,0,0,2-2V10A1.99945,1.99945,0,0,0,18,8Zm-6,9a2,2,0,1,1,2-2A1.99945,1.99945,0,0,1,12,17Zm3.1-9H8.9V6a3.1,3.1,0,1,1,6.2,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualIcon);
export default __webpack_public_path__ + "static/media/IndividualIcon.79359cb47f487c5a08a220303d919288.svg";
export { ForwardRef as ReactComponent };